// src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import { ThemeProvider } from './context/ThemeContext';
import { initSentry } from './utils/sentry';
import ErrorBoundary from './components/ErrorBoundary';
import './styles/variables.css'; // CSS variables first for proper cascade
import './styles/App.css';
import './styles/media.css';

// Initialize Sentry before rendering
initSentry();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Router>
        <ThemeProvider>
          <App />
        </ThemeProvider>
      </Router>
    </ErrorBoundary>
  </React.StrictMode>
);